module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//5.jpg?12bdc18bd07108867e476a8814d1a9ff";